import api from "../../http";

export default class ApiAboutFirstSection {
  static async getApiAboutFirstSection(url) {
    return api.get(url)
  }
}